import React, { Component } from 'react';
import { AppBar, Form } from './components'
import './App.css';
import { blue, red } from '@mui/material/colors';
import { ThemeProvider, createTheme } from '@mui/material';

const theme = createTheme({
  palette: {
    primary: blue,
    secondary: red,
  },
});

class App extends Component {
  render() {
    return (
      <ThemeProvider theme={theme}>
        <AppBar />
        <Form />

        {/* User message */}
        {/*<Paper style={{ position: 'absolute', left: '50%', top: '50%', padding: 20, transform: 'translate(-50%, -50%)' }} elevation={1}>
          <Typography align="center" variant="h6">
            Text
          </Typography>
        </Paper>*/}
      </ThemeProvider >
    );
  }
}

export default App;
